/*
 * @Author: your name
 * @Date: 2021-12-23 16:23:35
 * @LastEditTime: 2022-01-13 14:35:22
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\api\customer\customerApi.js
 */
import { postFetch, getFetch } from '@/utils/request'

export function getCustomerInfoData() {
    return getFetch('/customerInfo/getCustomerInfo', {})
}

export function getLoginAccountData() {
    return getFetch('/customerInfo/getLoginAccount', {})
}

export function getAccountData(accountId) {
    return getFetch('/customerInfo/getAccount', {customerAccountId: accountId})
}

export function getAccountListData() {
    return getFetch('/customerInfo/getAccountList', {})
}

export function checkAccountPasswordData(password) {
    return postFetch("/customerInfo/checkAccountPassword", null, {password: password})
}

export function modifyAccountBaseInfoData(account) {
    return postFetch('/customerInfo/modifyAccountBaseInfo', null, account)
}

export function modifyEnterpriseData(enterprise) {
    return postFetch('/customerInfo/modifyEnterprise', null, enterprise);
}

export function checkMobileIsExistData(mobile, isLogin) {
    return getFetch('/customerInfo/checkMobileIsExist', {mobile: mobile, isCheckLoginMobile:isLogin})
}

export function modifyLoginNameData(loginName) {
    return getFetch('/customerInfo/modifyLoginName',{loginName: loginName})
}

export function modifyMobileData(mobile, smsCode) {
    return postFetch('/customerInfo/modifyMobile', null, {mobile: mobile, msgCode: smsCode})
}

export function modifyPasswordData(password) {
    return postFetch('/customerInfo/modifyPassword', null, {password: password})
}

export function getCustomerInvoiceData(accountId) {
    return getFetch('/customerInfo/getCustomerInvoice', {accountId: accountId})
}

export function saveInvoiceData(invoice) {
    return postFetch('/customerInfo/saveInvoice', null, invoice)
}

export function saveInvoiceAddressData(invoiceAddress) {
    return postFetch('/customerInfo/saveInvoiceAddress', null, invoiceAddress)
}

export function saveAccountData(account) {
    return postFetch('/customerInfo/saveAccount', null, account)
}

export function getInvoiceTypesData() {
    return getFetch('/customerInfo/getInvoiceTypes', {})
}

export function getFullAccountInfo() {
    return getFetch('/customerInfo/getFullAccountInfo', {})
}

export function getReceiptBank() {
    return getFetch('/customerInfo/getReceiptBank', {})
}


// WEBPACK FOOTER //
// ./src/api/customer/customerApi.js